<template>
  <div>
    <SellHeader :img_header="header_image" header="คำสั่งซื้อ" link_back="sell/orderothermain"/>
    <Order_other_detail/>
  </div>
</template>

<script>
import SellHeader from "@/components/admin/sell/header_sell/SellHeader";
import HeaderImage from "@/assets/customer_sell.png";
import Order_other_detail from "@/components/admin/sell/Order_other_detail";
export default {
  name: "OrderOtherDetail",
  components: {
    Order_other_detail,
    SellHeader
  },
  data() {
    return {
      header_image: HeaderImage
    }
  }
}
</script>

<style scoped>

</style>
